export default Object.freeze({
  SET_COMPANY_DETAILS: 'SET_COMPANY_DETAILS'
});
